// import axios from 'axios'
// import {getApiUrl} from '@/api/utils/api-url'

export async function getNextCandidate(nextCandidate=0, imageKeys=[]) {
	let band_usno = Math.floor(3.99*Math.random())
	let band_PS1 = band_usno % 2
	console.log("band:",band_usno, band_PS1)
	return { data: { _id: nextCandidate,
						image_key: nextCandidate,
						usno_band: band_usno,
						panstarr_band: band_PS1,
						v: null
					 }
			 }
	// return searchAI(D,nextCandidate)
	// const queryParams = imageKeys.length > 0 ? `?exclude_image_keys[]=${imageKeys}` : ''
  // return axios.get(`${getApiUrl()}/candidates/best${queryParams}`)
}
